import React from "react";
import SweetAlert from "react-bootstrap-sweetalert";

export default function InfoAlert(props) {
  const { show, message, onConfirm } = props;
  return (
    <SweetAlert info title="Info" show={show} onConfirm={onConfirm}>
      <p className="sweet-alert-text">{message ? message : "..."}</p>
    </SweetAlert>
  );
}
